import * as React from 'react'
import type { SVGProps } from 'react'
const SvgCancel = (props: SVGProps<SVGSVGElement>) => (
	<svg viewBox="0 0 24 24" {...props}>
		<path d="M12 4C7.5912 4 4 7.5912 4 12C4 16.4088 7.5912 20 12 20C16.4088 20 20 16.4088 20 12C20 7.5912 16.4088 4 12 4ZM12 5.6C15.5441 5.6 18.4 8.4559 18.4 12C18.4 15.5441 15.5441 18.4 12 18.4C8.4559 18.4 5.6 15.5441 5.6 12C5.6 8.4559 8.4559 5.6 12 5.6ZM9.36562 8.23438L8.23438 9.36562L10.8688 12L8.23438 14.6344L9.36562 15.7656L12 13.1312L14.6344 15.7656L15.7656 14.6344L13.1312 12L15.7656 9.36562L14.6344 8.23438L12 10.8688L9.36562 8.23438Z" fill="currentColor"/>
	</svg>
)
export default SvgCancel
